// removed by extract-text-webpack-plugin
module.exports = {"Button":"Button__Button__QI7b2","Confirmation":"Button__Confirmation__1s_l4","MsgSubmit":"Button__MsgSubmit__2Va92","NavigationItem":"Button__NavigationItem__2G8Uv","AsLink":"Button__AsLink__1LyDG","Success":"Button__Success__2dHUt","Danger":"Button__Danger__2xnhN","Menu":"Button__Menu__2-10V","Chat":"Button__Chat__DEX1v","Reminder":"Button__Reminder__ju4X1","Rule":"Button__Rule__14BsU","Link":"Button__Link__1qWIe","GameMenu":"Button__GameMenu__1SMfr","BackToTopBtn":"Button__BackToTopBtn__1Rz1H","ResetBtn":"Button__ResetBtn__7auEP","ScrollToTop":"Button__ScrollToTop__3Anwr","Wide":"Button__Wide__3EJ-D"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Button/Button.css
// module id = 320
// module chunks = 0